import { t } from '@/utils/i18nUtils';

export enum DeleType {
  Single = 'single',
  All = 'all',
}

export const FocusKey = {
  HistoryPage: 'history-page',
  HistoryPageLoginBtn: 'history-page-login-btn',
  HistoryPageVideoType: 'history-page-module-video-type',
  HistoryPageModulePoster: 'history-page-module-poster',
  HistoryPageDeleteModalSingleBtn: 'history-page-delete-modal-single-btn',
  HistoryPageDeleteModalAllBtn: 'history-page-delete-modal-all-btn',
};

export const historyModuleDeleteModalBtn = [
  {
    type: DeleType.Single,
    text: t('history.deleteCurHistory'),
    focusKey: FocusKey.HistoryPageDeleteModalSingleBtn,
  },
  {
    type: DeleType.All,
    text: t('history.deleteAllHistory'),
    focusKey: FocusKey.HistoryPageDeleteModalAllBtn,
  },
];

export const HistoryPageText = {
  title: t('history.title'),
  deleteTip: t('history.deleteTip'),
  noLoginTip: t('history.noLoginTip'),
  login: t('history.login'),
  today: t('history.today'),
  week: t('history.week'),
  early: t('history.early'),
  deleteConfirmTip: t('history.deleteConfirmTip'),
  deleteCurHistory: t('history.deleteCurHistory'),
  deleteAllHistory: t('history.deleteAllHistory'),
  deleteHistoryFail: t('history.deleteHistoryFail'),
  empty: t('history.empty'),
  watchTo: t('channelPage.watchto'),
  watchUnLessOnePercent: t('channelPage.lessthan1%'),
};
